import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { FormattedHTMLMessage } from 'sb-react-intl'
import { constants, formatPrice, fbq } from 'common/helpers'

import DialogModal from 'components/modals/DialogModal/DialogModal'

import messages from './messages'
import s from './ResubscribeSuccessModal.scss'


class ResubscribeSuccessModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.resubscribe.ResubscribeSuccess,
  }

  componentDidMount() {
    const { data: { monthlyPrice }, subscriptionPrice } = this.props

    fbq.track('Resubscribe', {
      value: monthlyPrice || subscriptionPrice,
      currency: 'USD',
    })
  }

  render() {
    const { name, data } = this.props

    return (
      <DialogModal
        name={name}
        title={messages.title}
        data={data}
      >
        <FormattedHTMLMessage className={s.text} tag="div" {...messages.text} />
      </DialogModal>
    )
  }
}


export default connect({
  subscriptionPrice: (state) => formatPrice(state.models.subscription.price, true, false),
})(ResubscribeSuccessModal)
